import React, { useEffect, useRef } from 'react';
import { createStyles } from 'antd-style';
import { MessageItem, ChatMessage } from './MessageItem';

const useStyles = createStyles(() => ({
    messagesContainer: {
        flex: 1,
        overflowY: 'auto',
        padding: '16px',
        // backgroundColor: '#f5f5f5',
        maxHeight: '400px',
    },
    emptyState: {
        textAlign: 'center',
        padding: '50px',
        color: '#999',
    },
}));

interface MessageListProps {
    messages: ChatMessage[];
    currentUserRole?: string;
}

export const MessageList: React.FC<MessageListProps> = ({ messages, currentUserRole = 'cp' }) => {
    const { styles } = useStyles();
    const messagesEndRef = useRef<HTMLDivElement>(null);

    // 滚动到底部
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    // 当消息更新时滚动到底部
    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    // 判断是否是当前用户的消息
    const isMyMessage = (message: ChatMessage) => {
        return message.senderRole === currentUserRole;
    };

    return (
        <div className={styles.messagesContainer}>
            {messages.length === 0 ? (
                <div className={styles.emptyState}>
                    暂无聊天记录，开始对话吧！
                </div>
            ) : (
                messages.map((message, index) => (
                    <MessageItem
                        key={message.id || index}
                        message={message}
                        isMyMessage={isMyMessage(message)}
                        index={index}
                        previousMessage={index > 0 ? messages[index - 1] : null}
                    />
                ))
            )}
            <div ref={messagesEndRef} />
        </div>
    );
}; 